import InvestorTransactionsPage from "./InvestorTransactionsPage"

export default InvestorTransactionsPage
